import { Checkbox, Form, Input, Space, Typography } from "antd";
import _ from "lodash";
import React from "react";
import { useTranslation } from "react-i18next";
import { ICounselingFormBaseProps } from "../interface";

const { Text } = Typography;

const CounselingFormCheckBox: React.FC<ICounselingFormBaseProps> = ({
  question,
  disabled,
  forPrint,
}) => {
  const { t } = useTranslation();
  const formName = `${question.id}-${question.type}`;
  return (
    <Form.Item
      shouldUpdate={(prevValues, curValues) =>
        prevValues[formName] !== curValues[formName]
      }
      className="mb0"
    >
      {({ getFieldValue }) => (
        <Form.Item
          name={formName}
          label={question.question}
          rules={[
            {
              required: Boolean(question.is_required),
              message: t("validation.required", {
                item: "Answer",
              }),
            },
          ]}
          tooltip={question.tooltip}
        >
          {forPrint ? (
            <Checkbox.Group disabled={disabled}>
              {_.isArray(question.answers) &&
                question.answers.map((answer, index) => (
                  <Checkbox value={answer} key={`${index}-${formName}`}>
                    {typeof answer === "string" ? answer : ""}
                  </Checkbox>
                ))}
              {Boolean(question.is_others) && (
                <Checkbox value={"other"}>
                  <Space align="center">
                    <Text>Other</Text>
                    {getFieldValue(formName)?.includes("other") && (
                      <Form.Item
                        className="mb0"
                        name={`${question.id}-${question.type}-other`}
                        rules={[
                          {
                            required: true,
                            message: t("validation.required", {
                              item: "Answer",
                            }),
                          },
                        ]}
                      >
                        <Input
                          disabled={disabled}
                          size={"middle"}
                          placeholder={t("common.text.input", {
                            item: "Answer",
                          })}
                        />
                      </Form.Item>
                    )}
                  </Space>
                </Checkbox>
              )}
            </Checkbox.Group>
          ) : (
            <Checkbox.Group disabled={disabled}>
              <Space direction="vertical">
                {_.isArray(question.answers) &&
                  question.answers.map((answer, index) => (
                    <Checkbox value={answer} key={`${index}-${formName}`}>
                      {typeof answer === "string" ? answer : ""}
                    </Checkbox>
                  ))}
                {Boolean(question.is_others) && (
                  <Checkbox value={"other"}>
                    <Space align="center">
                      <Text>Other</Text>
                      {getFieldValue(formName)?.includes("other") && (
                        <Form.Item
                          className="mb0"
                          name={`${question.id}-${question.type}-other`}
                          rules={[
                            {
                              required: true,
                              message: t("validation.required", {
                                item: "Answer",
                              }),
                            },
                          ]}
                        >
                          <Input
                            disabled={disabled}
                            size={"middle"}
                            placeholder={t("common.text.input", {
                              item: "Answer",
                            })}
                          />
                        </Form.Item>
                      )}
                    </Space>
                  </Checkbox>
                )}
              </Space>
            </Checkbox.Group>
          )}
        </Form.Item>
      )}
    </Form.Item>
  );
};

export default CounselingFormCheckBox;
